import { Fragment, type FC, type ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { trackBreadcrumbClick } from './helpers/photosSearchBrowseTracking.ts';

import styles from './PhotosSearchBrowseBeardcrumbs.scss';

type BreadCrumbsItem = {
    label: ReactNode | string;
    tracking?: string;
    path?: string;
};

export const PhotosSearchBrowseBeardcrumbs: FC<{ pathFacet: string }> = ({ pathFacet }) => {
    const breadcrumbs: BreadCrumbsItem[] = [
        {
            label: (
                <FormattedMessage
                    id="abt.PhotosSearchBrowseBeardcrumbs.home"
                    defaultMessage="Home"
                />
            ),
            tracking: 'home',
            path: '/',
        },
        {
            label: (
                <FormattedMessage
                    id="abt.PhotosSearchBrowseBeardcrumbs.photos"
                    defaultMessage="Photos"
                />
            ),
            tracking: 'photos',
            path: '/photos/',
        },
    ];

    if (pathFacet) {
        breadcrumbs.push({ label: pathFacet });
    }

    return (
        <div className={styles.wrapper} data-tn="photos-breadcrumbs">
            {breadcrumbs.map((breadcrumb, index) => {
                const notLast = index < breadcrumbs.length - 1;
                const label = breadcrumb.label;
                return (
                    <Fragment key={index}>
                        <div className={styles.crumb} data-tn="photos-breadcrumb">
                            {notLast && breadcrumb.path ? (
                                <Link
                                    href={breadcrumb.path}
                                    className={styles.crumbLink}
                                    onClick={event =>
                                        trackBreadcrumbClick(
                                            {
                                                breadcrumb:
                                                    breadcrumb.tracking ||
                                                    (typeof label === 'string' ? label : ''),
                                            },
                                            event
                                        )
                                    }
                                >
                                    {label}
                                </Link>
                            ) : (
                                label
                            )}
                        </div>
                        {notLast && <div className={styles.crumb}>/</div>}
                    </Fragment>
                );
            })}
        </div>
    );
};
